const PARTNERS = {
  //getRenters
  RENTERS: 'RENTERS',
  //getPartnerDetails
  RENTERS_DETAILS: 'RENTERS_DETAILS',
  //getPartnerBankAccount
  PARTNER_BANK_ACCOUNT: 'PARTNER_BANK_ACCOUNT',
  //getPartnerContacts
  PARTNER_CONTACTS: 'PARTNER_CONTACTS',
  //getPartnerLogs
  PARTNER_LOGS: 'PARTNER_LOGS',
  //getPartnerObjects
  PARTNER_OBJECTS: 'PARTNER_OBJECTS',
  //deleteContact
  DELETE_CONTACT: 'DELETE_CONTACT',
  //updatePartnerContact
  UPDATE_PARTNER_CONTACT: 'UPDATE_PARTNER_CONTACT',
  //getPartnersCalculationDetails
  CREATE_PARTNER_CONTACT: 'CREATE_PARTNER_CONTACT',
  //getPartnerDocuments
  GET_PARTNER_DOCUMENTS: 'GET_PARTNER_DOCUMENTS',
  //getPartnerDocumentsByYear
  GET_PARTNER_DOCUMENTS_YEAR: 'GET_PARTNER_DOCUMENTS_YEAR',
  //getPartnerCalculationsDetails
  PARTNER_CALCULATION_DETAILS: 'PARTNER_CALCULATION_DETAILS',
  //getLogTypes
  LOG_TYPES: 'LOG_TYPES',
  //getParterComments
  PARTNER_COMMENTS: 'PARTNER_COMMENTS',
  //getPartnerCommentsDetails
  PARTNER_COMMENTS_DETAILS: 'PARTNER_COMMENTS_DETAILS',

  PARTNERS_COUPONS_LIST: 'PARTNERS_COUPONS_LIST',
  PARTNERS_COUPONS: 'PARTNERS_COUPONS',
  PARTNERS_COUPON_DETAILS: 'PARTNERS_COUPON_DETAILS',
  PARTNER_COUPON_DETAILS: 'PARTNER_COUPON_DETAILS',
  PARTNER_COUPON_PAGE_DESCRIPTION: 'PARTNER_COUPON_PAGE_DESCRIPTION',
  PARTNER_COUPON_CODES: 'PARTNER_COUPON_CODES',
  PARTNER_COUPON_CODES_REDEEM: 'PARTNER_COUPON_CODES_REDEEM',
  PARTNER_COUPON_CODES_REUSE: 'PARTNER_COUPON_CODES_REUSE',
  PARTNER_TEMPLATES: 'PARTNER_TEMPLATES',
};

export default PARTNERS;
